import React, { useEffect, useState } from 'react';
import { FormConfig } from '../../../components/Fields/Types';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import useValidation from '../../../components/Hooks/ValidationHook/useValidation';
import Authorize from '../../../components/AuthComponent/Authorize';
import SaveButton from '../../../components/Buttons/SaveButton';
import ButtonBar from '../../../components/Fields/ButtonBar';
import DataService from "../../../services/data.service";
import { ItemRevisionProps } from '../../../types/IdProps';
import { Result, DataResult } from '../../../types/Result';
import ItemEmployeeField from '../Components/ItemEmployeeField';
import ItemEmployeeModel from '../../../models/ItemEmployeeModel';

const ItemRevision_tab_Employees: React.FC<ItemRevisionProps> = ({ itemId, itemRevisionId, itemTypeId }) => {
    const [formData, setFormData] = useState<ItemEmployeeModel[]>();
    const [serverErrors, setServerErrors] = useState<DataResult<ItemEmployeeModel[]>>({ isSuccesful: true, messages: [], data: [] });
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getFormData();
    }, [itemRevisionId]);

    function getFormData() {
        DataService.get<ItemEmployeeModel[]>('api/v1/ItemEmployees/ByItemRevision/' + itemRevisionId)
            .then(response => {
                setFormData(response);
            })
            .catch(e => { handleException(e); });
    }

    function submit() {
        if (formData) {
            DataService
                .put<DataResult<ItemEmployeeModel[]>>(`api/v1/ItemEmployees/UpdateCollection`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    getFormData();
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        if (formData) {
            name.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setFormData(formData);
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, formData);
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    if (formData) {
        formData.forEach((itemEmployee, index) => {
            if (itemEmployee.isRequired) {
                formConfig.fields.push({ name: index + '.employeeId', label: itemEmployee.functionalRole.name, validationRules: [{ type: 'isRequired' }] });
            } else {
                formConfig.fields.push({ name: index + '.employeeId', label: itemEmployee.functionalRole.name });
            }
        });
    }

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!formData)
        return null;

    var fields = formData.map((itemEmployee: ItemEmployeeModel, index: number) => {
        return <ItemEmployeeField {...getFieldProps(index + '.employeeId')} itemEmployee={itemEmployee} key={index} />
    });

    return (
        <>
            {fields}
            <ButtonBar offset={2}>
                <Authorize applicationFunction={ApplicationFunctions.UpdateItemRevision} itemTypeId={itemTypeId}>
                    <SaveButton  {...getSubmitButtonProps()} />
                </Authorize>
            </ButtonBar>
        </>
    );
}
export default ItemRevision_tab_Employees;